export const isMacOS =
  typeof navigator !== 'undefined' && navigator.platform
    ? navigator.platform.toUpperCase().indexOf('MAC') >= 0
    : false;

function isSetEqual(a, b) {
  return a.size === b.size && [...a].every((value) => b.has(value));
}

function defaultCondition() {
  return true;
}

export class Action {
  constructor({ name, handler, shortcuts = '', icon, condition = defaultCondition, command }) {
    this.name = name;
    this.handler = handler;
    this.shortcuts = Array.isArray(shortcuts) ? shortcuts : [shortcuts];
    this.condition = condition;
    this.icon = icon;
    this._command = command;
  }

  isDisabled(ctx) {
    if (!this.condition) {
      return false;
    }
    return !this.condition(ctx);
  }

  match(set) {
    return this.shortcutsSets.find((s) => isSetEqual(set, s));
  }

  get shortcutsSets() {
    return this.shortcuts.map((s) => this.shortcutsToSet(s));
  }

  shortcutsToSet(shortcuts) {
    return new Set(
      shortcuts
        .split('+')
        .map((s) => s.trim())
        .map((s) => s.toUpperCase())
    );
  }

  get command() {
    const command = this._command || this.shortcuts[0] || '';
    return Action.command(command);
  }

  run(...args) {
    this.handler(...args);
  }
}

/**
 * Convert a command string to a platform-specific representation
 * @param {string} command
 * @returns {string}
 */
Action.command = (command) => {
  command = command || '';
  if (isMacOS) {
    return command
      .replace('Ctrl', '⌘')
      .replace('Alt', '⌥')
      .replace('Shift', '⇧')
      .replace('Backspace', '⌫');
  }
  return command;
};
